import moment from "moment";

import { NameHelper, NameHelperFormat } from "@/Common/Helpers/NameHelper";
import { PatientHelper } from "@/Common/Helpers/PatientHelper";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { EmailAddressDto, MailingAddressDto, TelephoneNumberDto } from "@/Common/Models/Portal/MedfarPortal";
import { MedicalSex } from "@/Common/Models/Portal/MedfarPortalEnums";
import { FormattedPhoneNumber } from "@/Common/Models/Portal/Patient/FormattedPhoneNumber";
import { PatientProfileMyleDto } from "@/Common/Models/Portal/Patient/SharedPatientMyleDto";

import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

type PatientPortalCallbackFunction = (patient: PatientProfileMyleDto) => void;
type PatientPortalPhoneCallbackFunction = (patient: PatientProfileMyleDto, phone: TelephoneNumberDto) => void;

interface IPatientPortalBanner {
    patient: PatientProfileMyleDto;
    patientNameClickCallback: PatientPortalCallbackFunction;
    patientNAMClickCallback: PatientPortalCallbackFunction;
    patientPhoneClickCallBack: PatientPortalPhoneCallbackFunction;
}

class PatientPortalBanner extends React.Component<IPatientPortalBanner, any> {
    private validationHelper: ValidationHelper = new ValidationHelper();

    public render(): JSX.Element {
        let result: JSX.Element = null;

        const prefixLookupCode = this.getMyPrefix(this.props.patient.Sex);
        const prefix = cacheStore.GetLocalizedValueByLookupId(cacheStore.FindLookupByLookupCode(prefixLookupCode).LookupID);
        const dobString = moment.utc(this.props.patient.DateOfBirth).format("YYYY/MM/DD");
        const ageString = PatientHelper.getFormattedAge(new Date(dobString));

        result = (
            <div className="patient-view">
                <div className="flex-container patient psr">
                    <div className="logo"><img src={img_p_banner_icon_100} alt="MYLE" style={{ width: "48px" }} /></div>
                    <div className="demographics">
                        <div> {prefix} <a className="name" onClick={this.onPortalPatientNameClick.bind(this)}> {NameHelper.formatFullNameForHasName(this.props.patient, NameHelperFormat.UpperLastNameFirst)}</a></div>
                        <div><span>{cacheStore.GetString("HealthCard")}</span> <a onClick={this.onPortalPatientNAMClick.bind(this)}> {this.props.patient.InsuranceNumber} </a></div>
                        <div><span>{cacheStore.GetString("DateofBirthLabel")}</span> <strong>{dobString} ({ageString}) </strong></div>
                    </div>
                </div>

                <div style={{ marginBottom: "5px" }}>
                    <div>
                        <h5 className="uppercase" />
                        <ul className="phone-list">
                            {this.props.patient.TelephoneNumbers.map((phone: TelephoneNumberDto, i: number) => {
                                let formattedPhoneNumber: FormattedPhoneNumber = PortalHelper.getFormattedPhoneNumber(phone, this.validationHelper);
                                return (
                                    <li key={i + "__npl"}>
                                        <div> <span className="myle-icon-16 phone" /> <a className="bold" onClick={this.patientPhoneClickCallBack.bind(this, phone)}>{formattedPhoneNumber.FormattedPhoneNumber}</a> <span>({formattedPhoneNumber.ContactType} - {formattedPhoneNumber.PhoneType}) </span></div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                        <h5 className="uppercase">{cacheStore.GetString("AddressLabel")}</h5>
                        <ul className="phone-list">
                            {this.props.patient.MailingAddresses.map((a: MailingAddressDto) => {
                                let formattedPostalCode = PortalHelper.getFormattedPostalCode(a, this.validationHelper);
                                return (
                                    <li key={a.MailingAddressId}>
                                        <div><strong>{a.StreetAddress}{a.Company == null || a.Company === "" ? "" : ", "}{a.Company}</strong></div>
                                        <div>
                                            <strong>{a.City}</strong>
                                            {a.Province != null && a.Province !== "" &&
                                                <strong>, {a.Province}</strong>
                                            }
                                        </div>
                                        <div><strong>{formattedPostalCode}</strong></div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                        <h5 className="uppercase">{cacheStore.GetString("EmailLabel")}</h5>
                        {this.renderEmails(this.props.patient.EmailAddresses)}
                    </div>
                </div>
            </div>
        );

        return result;
    }

    private getMyPrefix(medicalSex: MedicalSex): string {
        switch (medicalSex) {
            case MedicalSex.Male:
                return "PREFIX.MR";
            case MedicalSex.Female:
                return "PREFIX.MS";
            default:
                return "PREFIX.MX";
        }
    }

    private renderEmails(emails: EmailAddressDto[]): JSX.Element {
        if (!emails || emails.length === 0)
            return <div />;

        let emailList = emails.map(x => (
            <li key={x.EmailAddressId}>
                {x.Email}
            </li>
        ));

        return <ul className="phone-list">{emailList}</ul>;
    }

    private onPortalPatientNameClick(): void {
        if (this.props.patientNameClickCallback != null) {
            this.props.patientNameClickCallback(this.props.patient);
        }
    }

    private onPortalPatientNAMClick(): void {
        if (this.props.patientNAMClickCallback != null) {
            this.props.patientNAMClickCallback(this.props.patient);
        }
    }

    private patientPhoneClickCallBack(phoneNumber: TelephoneNumberDto): void {
        if (this.props.patientPhoneClickCallBack != null) {
            this.props.patientPhoneClickCallBack(this.props.patient, phoneNumber);
        }
    }
}

export { PatientPortalBanner };
